$(function () {
    function regenRows($container) {
        if ($container.length !== 1) {
            throw new Error()
        }
        if ($container.find('.rr-val').length !== 1) {
            throw new Error()
        }
        const data = {};
        $container.find('.rangerepeater-row').each(function () {
            const l = $(this).find('.rr-l').val() || 0;
            const r = $(this).find('.rr-r').val() || 0;
            data[l + '/' + r] = $(this).find('.rr-v').val();
        });
        $container.find('.rr-val').val(JSON.stringify(data));
    }

    const $body = $(document.body);

    /* ---- add new row ------------------------------------------------- */
    $body.on('click', '.action-new-rangerepeater', function () {
        const $cnt = $(this).parents('.rangerepeat-container');
        const newRowHtml = $cnt.find('.rangerepeater-template').html();
        $cnt.find('.rangerepeat-repeater').append($(newRowHtml).addClass('rangerepeater-row'));
        $cnt.trigger('freshEnds');
    });

    /* ---- delete row ------------------------------------------------- */
    $body.on('click', '.action-delete-row', function () {
        const $cnt = $(this).parents('.rangerepeat-container');
        const $row = $(this).closest('.rangerepeater-row');
        const $prev = $row.prev('.rangerepeater-row');
        const $next = $row.next('.rangerepeater-row');

        if ($next.length && $prev.length) {
            $next.find('.rr-l').val($prev.find('.rr-r').val()).trigger('change');
        }
        $row.remove();

        $cnt.trigger('freshEnds');
    });

    $body.on('freshEnds', '.rangerepeat-container', function () {
        const $c = $(this);
        const $rows = $c.find('.rangerepeater-row').not('');

        var end = $rows.length - 1;

        $rows.each(function (idx) {
            $(this).find('.rr-l').attr('disabled', idx === 0).attr('required', idx !== 0);
            $(this).find('.rr-r').attr('disabled', idx === end).attr('required', idx !== end);
            $(this).find('.rr-v').attr('disabled', false).attr('required', true);
            if (idx === 0) {
                $(this).find('.rr-l').val('');
            }
            if (idx === end) {
                $(this).find('.rr-r').val('');
            }
        });

        $rows.find('.action-delete-row').toggle($rows.length > 1);
        regenRows($(this));
    })
    $('.rangerepeat-container').trigger('freshEnds');

    /* ---- key/mouse events – sync left/right values ----------------- */
    $body.on('keydown keyup change', '.rr-l', function () {
        $(this).closest('.rangerepeater-row').prev().find('.rr-r').val($(this).val());
    }).on('keydown keyup change', '.rr-r', function () {
        $(this).closest('.rangerepeater-row').next().find('.rr-l').val($(this).val());
    });

    /* ---- regen hidden input ----------------------------------------- */
    $body.on('change regen', '.rangerepeater-row input', function () {
        regenRows($(this).parents('.rangerepeat-container'));
    });

    /* ------------------------------------------------------------------
       2️⃣  Copy / Paste
     -------------------------------------------------------------------*/
    /* ---- copy -------------------------------------------------------- */
    $body.on('click', '.action-copy-rangerepeater', function () {
        const $c = $(this).closest('.rangerepeat-container');//appendKeys, appendValues
        let txt = `Től (${$c.data('appendKeys')})\tIg (${$c.data('append-keys')})\tÉrték (${$c.data('append-values')})\n`;
        $c.find('.rangerepeater-row').each(function () {
            const l = ($(this).find('.rr-l').val() || '').replace(/\./,',');
            const r = ($(this).find('.rr-r').val() || '').replace(/\./,',');
            const v = ($(this).find('.rr-v').val() || '').replace(/\./,',');
            txt += `${l}\t${r}\t${v}\n`;
        });

        // Modern API
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(txt).catch(err => console.warn('Clipboard write failed', err));
        } else {
            // Fallback
            const ta = $('<textarea>');
            $('body').append(ta);
            ta.val(txt).select();
            document.execCommand('copy');
            ta.remove();
        }
    });

    /* ---- paste ------------------------------------------------------- */
    $body.on('click', '.action-paste-rangerepeater', function () {
        const $c = $(this).closest('.rangerepeat-container');

        /* ------------- helper ------------------------------------------------ */
        // Accept tabs or semicolons (Excel‑style).
        const delims = ';\t'.split('');

        const headerParts = [
            `Től (${$c.data('appendKeys')})`,
            `Ig (${$c.data('append-keys')})`,
            `Érték (${$c.data('append-values')})`
        ];

        /* ------------- clipboard read ---------------------------------------- */
        if (!navigator.clipboard || !navigator.clipboard.readText) {
            alert('Clipboard API nem elérhető (HTTPS szükséges).');
            return;
        }

        navigator.clipboard.readText().then(txt => {
            const lines = txt.trim().split(/\r?\n/);
            if (!lines.length) return;
            var delim = null;

            for (const d of delims) {
                /* ------------- header check ------------------------------------- */
                const firstLineParts = lines[0].trim().split(d).map(p => p.trim());
                if (firstLineParts.length === 3 ||
                    firstLineParts[0] === headerParts[0] ||
                    firstLineParts[1] === headerParts[1] ||
                    firstLineParts[2] === headerParts[2]) {
                    delim = d;
                    break;
                }
            }
            if(!delim){
                console.log(lines[0].trim(), headerParts);
                alert(
                    'Érvénytelen formátum! Az alábbi két sornak meg kell egyeznie\n' +
                    lines[0].trim() + '\n' + headerParts.join(';')
                );
                return;
            }

            /* ------------- parse rows ---------------------------------------- */
            const data = [];
            for (let i = 1; i < lines.length; i++) {
                const parts = lines[i].split(delim).map(p => p.trim());
                if (parts.length < 3) continue;   // skip malformed lines
                const [l, r, v] = parts;
                data.push({l, r, v});
            }

            if (!data.length) {
                alert('A beillesztendő tartalom üres.');
                return;
            }

            /* ------------- replace existing rows --------------------------- */
            $c.find('.rangerepeater-row').remove();

            const $repeater = $c.find('.rangerepeat-repeater');
            data.forEach(item => {
                const newRowHtml = $c.find('.rangerepeater-template').html();
                const $row = $(newRowHtml).addClass('rangerepeater-row');

                // fill the template
                $row.find('.rr-l').val((item.l).replace(/,/,'.'));
                $row.find('.rr-r').val((item.r).replace(/,/,'.'));
                $row.find('.rr-v').val((item.v).replace(/,/,'.'));

                $repeater.append($row);
            });

            /* ------------- re‑initialize UI --------------------------------- */
            $(this).parents('.rangerepeat-container').trigger('freshEnds');

        }).catch(err => console.warn('Clipboard read failed', err));
    });
});
